module.exports = __webpack_public_path__ + "img/synergy.238be76.svg";